module.exports = __webpack_public_path__ + "img/popularize01.fea1f2d4.png";